import type { Immutable } from "immer";
import React from "react";

import type { HorizontalRuleBlock as HorizontalRuleBlockValue } from "@reactivated";

const classList = (classes: Array<string | null | undefined>): string =>
    classes.filter(Boolean).join(" ");

export const HorizontalRuleBlock = (
    props: Immutable<{ value: HorizontalRuleBlockValue }>,
): React.JSX.Element => {
    return (
        <hr
            className={classList([
                "horizontal-rule-block",
                props.value.full_bleed ? "u-full-bleed" : null,
            ])}
        />
    );
};
